export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json'
};
// Our server timeout is 20s so it's with 10 seconds buffer.
export const REQUEST_TIMEOUT = 30000;
export const DEFAULT_RETRY_CONFIG = {
    retry: 0,
    noResponseRetries: 3, // Retry when there was no response (ENOTFOUND, ETIMEDOUT, etc)
    backoffType: 'exponential',
    retryDelay: 100,
    checkRetryAfter: false
};
//# sourceMappingURL=http-client.constants.js.map